<div class="cursor-pointer bg-[#ECECEE] w-[58px] h-[26px] rounded-[20px]"
    (click)="fireToggleLanguage()">

    <ng-container *ngIf="isEn">
        <div class="flex items-center gap-3 h-full justify-center">
            <span class="text-xs">EN</span>
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
                <defs>
                <clipPath id="clip-path">
                    <circle id="Ellipse_1" data-name="Ellipse 1" cx="10" cy="10" r="10" transform="translate(226.92 28.92)" fill="#093"/>
                </clipPath>
                </defs>
                <g id="Mask_Group_1" data-name="Mask Group 1" transform="translate(-226.92 -28.92)" clip-path="url(#clip-path)">
                <g id="Group_128510" data-name="Group 128510" transform="translate(225.608 28.92)">
                    <path id="Path_193756" data-name="Path 193756" d="M0,.059H22.622v20H0Z" transform="translate(0 -0.059)" fill="#000063" fill-rule="evenodd"/>
                    <g id="Group_128509" data-name="Group 128509">
                    <path id="Path_193759" data-name="Path 193759" d="M0,.059V2.3L20.093,20.059h2.529V17.823L2.529.059H0Zm22.622,0V2.3L2.529,20.059H0V17.823L20.093.059h2.529Z" transform="translate(0 -0.059)" fill="#fff"/>
                    <path id="Path_193760" data-name="Path 193760" d="M9.426.059v20H13.2v-20ZM0,6.726v6.667H22.622V6.726Z" transform="translate(0 -0.059)" fill="#fff"/>
                    <path id="Path_193761" data-name="Path 193761" d="M0,8.059v4H22.622v-4H0Zm10.18-8v20h2.262v-20ZM0,20.059l7.541-6.667H9.227L1.686,20.059Zm0-20L7.541,6.726H5.855L0,1.55ZM13.4,6.726,20.936.059h1.686L15.082,6.726H13.4Zm9.227,13.333-7.541-6.667h1.686l5.855,5.176v1.491Z" transform="translate(0 -0.059)" fill="#c00"/>
                    </g>
                </g>
                </g>
            </svg>
        </div>
    </ng-container>

    <ng-container *ngIf="!isEn">
        <div class="flex items-center gap-3 h-full justify-center">
            <span class="text-xs">AR</span>
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
                <defs>
                  <clipPath id="clip-path">
                    <circle id="Ellipse_1" data-name="Ellipse 1" cx="10" cy="10" r="10" transform="translate(226.92 28.92)" fill="#093"/>
                  </clipPath>
                </defs>
                <g id="Mask_Group_1" data-name="Mask Group 1" transform="translate(-226.92 -28.92)" clip-path="url(#clip-path)">
                  <g id="_2fd97f825479cd202dc7f9873505be31" data-name="2fd97f825479cd202dc7f9873505be31" transform="translate(224.92 28.92)">
                    <path id="Path_193762" data-name="Path 193762" d="M0,0H26V20H0Z" fill="#8d1b3d"/>
                    <path id="Path_193763" data-name="Path 193763" d="M0,0V20H6.435l3.971-1.111L6.435,17.778l3.971-1.111L6.435,15.556l3.971-1.111L6.435,13.333l3.971-1.111L6.435,11.111,10.406,10,6.435,8.889l3.971-1.111L6.435,6.667l3.971-1.111L6.435,4.444l3.971-1.111L6.435,2.222l3.971-1.111L6.435,0Z" fill="#fff"/>
                  </g>
                </g>
              </svg>             
        </div>
    </ng-container>

</div>